// utm-content-variant.js
// runtime.js 규칙: window.App.modules[key] = (el) => ({ init(){}, destroy(){} })

(function () {
  window.App = window.App || {};
  window.App.modules = window.App.modules || {};

  window.App.modules["utm-content-variant"] = (el) => {
    // --- 내부 상태 --- (중복 방지)
    let isInit = false;

    // --- 사용 가능 옵션 ---
    const opts = {
      // 기본: utm_content (Meta: {{adset.name}})
      param: el.dataset.param || "utm_content",

      // 필요 시 fallback도 가능 (예: utm_campaign)
      // <div data-mount="..." data-fallback="utm_campaign">
      fallback: el.dataset.fallback || "",

      // utm이 내부 이동에서 사라질 수 있어 세션 유지하고 싶으면:
      // <div data-mount="..." data-persist>
      persist: el.hasAttribute("data-persist"),

      // persist 저장 키
      storageKey: el.dataset.storageKey || "utm_content",

      // 노출 대상 selector (기본: data-variant)
      selector: el.dataset.selector || "[data-variant]",

      // destroy 시 hidden을 원복하고 싶으면:
      // <div data-mount="..." data-reset-on-destroy>
      resetOnDestroy: el.hasAttribute("data-reset-on-destroy"),

      debug: el.hasAttribute("data-debug"),
    };

    // --- 유틸 ---
    const normalize = (v) =>
      (v || "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "_")         // 공백 → _
        .replace(/[^a-z0-9_-]/g, ""); // 안전문자만

    const getParam = (name) => {
      if (!name) return "";
      return new URLSearchParams(window.location.search).get(name) || "";
    };

    const resolveKey = () => {
      const raw = getParam(opts.param) || getParam(opts.fallback);

      if (opts.persist) {
        if (raw) {
          sessionStorage.setItem(opts.storageKey, raw);
          return normalize(raw) || "default";
        }

        // 🔥 UTM이 없으면: 이전 세션값을 지워서 default로 복귀
        sessionStorage.removeItem(opts.storageKey);
        return "default";
      }

      return normalize(raw) || "default";
    };

    const apply = (key) => {
      const nodes = el.querySelectorAll(opts.selector);
      if (!nodes.length) return;

      let hasExact = false;
      nodes.forEach((node) => {
        const k = normalize(node.getAttribute("data-variant"));
        if (k && k !== "default" && k === key) hasExact = true;
      });

      nodes.forEach((node) => {
        const k = normalize(node.getAttribute("data-variant"));
        const isActive = k === key || (!hasExact && k === "default");

        // 기존 숨김처리 유지
        node.hidden = !isActive;

        // (원하면) active 클래스도 같이
        node.classList.toggle("is-active", isActive);
      });

      // ✅ JS 적용 완료 표시 (FOUC 방지)
      el.classList.add("is-variant-ready");

      if (opts.debug) {
        console.log("[utm-content-variant]", { key, opts, el });
      }
    };

    // --- URL change 대응 (필요 최소) ---
    // popstate: 뒤로/앞으로
    const onPopState = () => {
      if (!isInit) return;
      apply(resolveKey());
    };

    // shopify theme editor에서 section reload될 땐 runtime이 init/destroy 해주니까
    // 여기서는 popstate만 가볍게 대응해도 충분한 편.

    return {
      init() {
        if (isInit) return;
        isInit = true;

        apply(resolveKey());
        window.addEventListener("popstate", onPopState);
      },

      destroy() {
        if (!isInit) return;
        isInit = false;

        window.removeEventListener("popstate", onPopState);

        el.classList.remove("is-variant-ready"); // ✅ 추가

        if (opts.resetOnDestroy) {
          el.querySelectorAll(opts.selector).forEach((node) => {
            node.hidden = false;
            node.classList.remove("is-active");
          });
        }
      },
    };
  };
})();
